<template>
  <div class="sign-page">
    <div class="content">
      <div class="success" v-if="code == 0">
        <p>你已经成功领取 3 小时高速线路</p>
        <van-icon class="success" name="success" />
      </div>
      <div class="warning" v-if="code == 10205">
        <p>本周 3 小时高速线路已经领取</p>
        <p>请下周再来领取~</p>
        <van-icon class="warning" name="fail" />
      </div>
    </div>
  </div>
</template>

<script>
import { signWeek } from '@/api/user'
export default {
  data () {
    return {
      code: -1
    }
  },
  async mounted() {
    const res = await signWeek()
    this.code = res.code
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_var.scss';
.content {
  margin: 20px auto;
  max-width: 600px;
  padding: 20px 40px;
  border-radius: 4px;
  border: 1px solid #eee;
  text-align: center;
  font-size: 16px;
  p {
    line-height: 2;
    font-weight: bold;
  }
  .van-icon {
    margin-top: 10px;
    height: 60px;
    width: 60px;
    line-height: 54px;
    border-radius: 50%;
    font-size: 40px;
    &.warning {
      border: 4px solid $warning-color;
    }
    &.success {
      border: 4px solid $success-color;
    }
  }
}
</style>
